import { library, icon } from "@fortawesome/fontawesome-svg-core";

//light:
// import {
//   faPlayCircle
// } from '@fortawesome/pro-light-svg-icons/faPlayCircle';
//
// import {
//   faUndo
// } from '@fortawesome/pro-light-svg-icons/faUndo';
//
// import {
//   faPause
// } from '@fortawesome/pro-light-svg-icons/faPause';
//
// import {
//   faSpinner
// } from '@fortawesome/pro-light-svg-icons/faSpinner';

import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faGlasses } from "@fortawesome/pro-light-svg-icons/faGlasses";

import { faLongArrowRight } from "@fortawesome/pro-light-svg-icons/faLongArrowRight";

import { faArrowFromRight } from "@fortawesome/pro-light-svg-icons/faArrowFromRight";

import { faArrowFromLeft } from "@fortawesome/pro-light-svg-icons/faArrowFromLeft";

import { faDirections } from "@fortawesome/pro-light-svg-icons/faDirections";

//solid:
// import {
//   faPlayCircle as faPlayCircleSolid
// } from '@fortawesome/pro-solid-svg-icons/faPlayCircle';
import { faArrowDown } from "@fortawesome/pro-solid-svg-icons/faArrowDown";

import { faEllipsisV } from "@fortawesome/pro-solid-svg-icons/faEllipsisV";

//brands:
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";

import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";

import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";

//regular:
import { faAngleUp } from "@fortawesome/pro-regular-svg-icons/faAngleUp";

library.add(
	//light:
	// faPlayCircle,
	// faUndo,
	// faPause,
	// faSpinner,
	faTimes,
	faLongArrowRight,
	faArrowFromRight,
	faArrowFromLeft,
	faGlasses,

	// solid:
	// faPlayCircleSolid,
	faArrowDown,
	faEllipsisV,

	//brands:
	faInstagram,
	faTwitter,
	faFacebookF,
	faYoutube,
	faLinkedinIn,
	faWhatsapp,

	//regular:
	faAngleUp,
	faDirections
);
